// getCenterPopupNotificationContentSize.js
'use strict';

import {
  getIsPortrait,
  getIsOnMobileBySize,
} from '../resource/getUserAgent.js';
import toEven from '../resource/toEven.js';
import {
  popupNotificationCenterCloseButtonHeight,
  popupNotificationCenterMaximumWidthInPortrait,
  popupNotificationCenterMaximumHeightInLandscape,
  popupNotificationCenterHorizontalPaddingInPortrait,
  popupNotificationCenterVerticalPaddingInLandscape,
  popupNotificationCenterContentHeightRatioInPortrait,
  popupNotificationCenterContentWidthRatioInLandscape,
} from '../style/variables.js';

const isServer = typeof window === 'undefined';

/**
 * @typedef Size
 * @property {number} width - content width.
 * @property {number} height - content height.
 */

/**
 * Get center popup notification content size.
 * @param {number} {[deviceWidth = 0]} - device width.
 * @param {number} {[deviceHeight = 0]} - device height.
 * @return {Size} content size.
 */
const getCenterPopupNotificationContentSize = ({
  deviceWidth = 0,
  deviceHeight = 0,
} = {}) => {
  const isPortrait = getIsPortrait();
  const isMobile = getIsOnMobileBySize();
  const size = {
    width: 0,
    height: 0,
  };

  if (isServer || [deviceWidth, deviceHeight].includes(0)) {
    return size;
  }

  let contentWidth = 0;
  let contentHeight = 0;

  if (!isMobile || isPortrait) {
    contentWidth = Math.min(
      deviceWidth - popupNotificationCenterHorizontalPaddingInPortrait * 2,
      popupNotificationCenterMaximumWidthInPortrait
    );
    contentHeight =
      contentWidth * popupNotificationCenterContentHeightRatioInPortrait;
  } else {
    contentHeight = Math.min(
      deviceHeight -
        popupNotificationCenterVerticalPaddingInLandscape * 2 -
        popupNotificationCenterCloseButtonHeight,
      popupNotificationCenterMaximumHeightInLandscape
    );
    contentWidth =
      contentHeight * popupNotificationCenterContentWidthRatioInLandscape;
  }

  size.width = toEven({ value: contentWidth });
  size.height = toEven({ value: contentHeight });

  return size;
};

export default getCenterPopupNotificationContentSize;
